import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import api from "../../../api/Api";
import { toast } from "react-toastify";

function AssignDetails() {
  const { identy } = useParams();
  const navigate = useNavigate();

  const [assign, setAssign] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get(`/api/assignments/${identy}`)
      .then(res => setAssign(res.data.response))
      .catch(() => setError("Failed to fetch assignment."));
  }, [identy]);

const handleEdit = () => navigate(`/assignments/edit/${identy}`);
console.log(`${process.env.REACT_APP_API_BASE_URL}/api/assignments/${identy}`);

  const handleDelete = () => {
    const confirmDelete = window.confirm("Are you sure you want to delete this assignment?");
    if (!confirmDelete) return;

    api
      .delete(`/api/assignments/${identy}`)
      .then(() => {
        toast.success("Assignment deleted successfully");
        navigate("/assignments")})
      .catch(err => {
        console.error(err);
        alert("Delete failed");
      });
  };

  if (error) return <p className="text-center text-danger mt-5">{error}</p>;
  if (!assign) return <p className="text-center mt-5">Loading assignment…</p>;

  return (
    <div className="container p-3" style={{height:'100%'}}>
      {/* Top Buttons */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Link to={`/assignments/name/${assign.employeeIdenty.identy}`} className="btn btn-secondary">← Back</Link>
        <div className="d-flex gap-2">
          <button className="btn btn-secondary" onClick={handleEdit}>Edit</button>
          <button className="btn btn-danger" onClick={handleDelete}>Delete / Unassign</button>
        </div>
      </div>

      {/* Details Card */}
      <div className="card p-3" style={{ maxHeight: '380px', overflowY: 'auto' }}>
        <div className="row">
          {/* Left Side: Dynamic Fields */}
          <div className="col-md-6">
            <h5 className="fw-bold mb-3">Assignment Details</h5>
            {
              Object.entries(assign)
                .filter(([key]) =>
                  !['identy', 'employeeIdenty','assetIdenty','createdBy', 'createdDate', 'modifiedBy', 'modifiedDate'].includes(key)
                )
                .map(([key, value]) => (
                  <div key={key} className="mb-2">
                    <strong className="text-capitalize">
                      {key.replace(/([A-Z])/g, ' $1')}:
                    </strong> {" "} 
                    {value === null || value === undefined || value === "" ? "N/A" : String(value)}
                  </div>
                ))
            }
          </div>

          {/* Right Side: Audit Info */}
          <div className="col-md-6">
            <h5 className="fw-bold mb-3">Audit Info</h5>
            <div className="mb-2"><strong>Created By:</strong> {assign.createdBy}</div>
            <div className="mb-2"><strong>Modified By:</strong> {assign.modifiedBy}</div>
            <div className="mb-2"><strong>Created Date:</strong> {assign.createdDate}</div>
            <div className="mb-2"><strong>Modified Date:</strong> {assign.modifiedDate}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssignDetails;
